import { doc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import { expandGambiaPhone, hashPin } from './policyCatalog';

export function randomLookupPin() {
    return String(1000 + Math.floor(Math.random() * 9000));
}

export async function saveClientPin({ tenantId, customerId, companyName, phone, pin }) {
    const code = String(pin || '').replace(/\D/g, '').slice(0, 4);
    if (code.length !== 4) throw new Error('PIN must be 4 digits');
    const phoneNormalized = expandGambiaPhone(phone);
    const pinHash = await hashPin(phoneNormalized, code);
    await updateDoc(doc(db, 'tenants', tenantId, 'customers', customerId), {
        lookupPin: code,
        pinIssued: true,
        pinUpdatedAt: new Date().toISOString()
    });
    await setDoc(doc(db, 'lookupIndex', tenantId + '_' + phoneNormalized), {
        phoneNormalized,
        pinHash,
        tenantId,
        customerId,
        companyName: companyName || ''
    });
    return code;
}
